import { twoFactorClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import { resolveAuthBaseURL } from "@/lib/auth-base-url";

export const authClient = createAuthClient({
  // Better Auth drops basePath whenever baseURL already has a path, as the
  // previews' "/api" does, so the mount point is part of baseURL instead.
  baseURL: `${resolveAuthBaseURL(import.meta.env.VITE_API_URL, window.location.origin)}/auth`,
  // The session is an httpOnly cookie, so it has to be sent explicitly on
  // cross-origin requests and cannot be read back by anything here.
  fetchOptions: { credentials: "include" },
  plugins: [twoFactorClient()],
});
